import { createFeatureSelector } from '@ngrx/store';

export const geolocationState = createFeatureSelector<OLO.State, OLO.State.Geolocation>('geolocation');
